import { isMatchMediaAvailable as e } from "../utils/theme.js";
import { c as t } from "react/compiler-runtime";
import { useEffect as n, useState as r } from "react";
//#region src/hooks/useMatchMedia.ts
var i = (i) => {
	let o = t(5), s;
	o[0] === i ? s = o[1] : (s = () => a(i), o[0] = i, o[1] = s);
	let [c, l] = r(s), u, d;
	return o[2] === i ? (u = o[3], d = o[4]) : (u = () => {
		if (!e()) return;
		let t = window.matchMedia(i), n = (e) => {
			l(e.matches);
		};
		return t.addEventListener("change", n), () => {
			t.removeEventListener("change", n);
		};
	}, d = [i], o[2] = i, o[3] = u, o[4] = d), n(u, d), c;
}, a = (t) => {
	if (e()) return window.matchMedia(t).matches;
};
//#endregion
export { i as useMatchMedia };
